import classNames from "classnames";

import {Table} from "@/components/table/Table.tsx";

import {MarketingTableProps} from "./MarketingTable.types.ts";

import styles from "./MarketingTable.module.scss";

const MAX_ROWS_WITH_OVERLAY = 7;
const MIN_ROWS_WITH_OVERLAY = 4;

export const MarketingTable = <T,>({variant = "default", overlay, rows, ...props}: MarketingTableProps<T>) => {
  const hasBlur = rows.length >= MIN_ROWS_WITH_OVERLAY;

  return (
    <div className={classNames(styles.tableContainer, {[styles.hasOverlay]: overlay, [styles.withoutBlur]: !hasBlur})}>
      {overlay && <div className={classNames(styles.overlay, styles.overlayMobile)}>{overlay}</div>}
      <Table
        className={classNames(styles.table, styles[variant])}
        rows={overlay ? rows.slice(0, MAX_ROWS_WITH_OVERLAY) : rows}
        {...props}
      />
      {overlay && (
        <>
          {hasBlur && <div className={styles.overlayBlur} />}
          <div className={classNames(styles.overlay, styles.overlayDefault, {[styles.overlayWithoutBlur]: !hasBlur})}>
            {overlay}
          </div>
        </>
      )}
    </div>
  );
};
